import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/functions';
import 'firebase/compat/database';
import 'firebase/compat/app-check';

const firebaseConfig = {
  apiKey: 'AIzaSyBunF4W9sZ0tjCdgcrIw-tZZq2DWd_fGbI',
  authDomain: 'konjo-18eba.firebaseapp.com',
  databaseURL: 'https://konjo-18eba.firebaseio.com',
  projectId: 'konjo-18eba',
  storageBucket: 'konjo-18eba.appspot.com',
  messagingSenderId: '176880470815',
  appId: '1:176880470815:web:0eb3c8948a23fe8204fe2a',
  measurementId: 'G-0DNBZ7Y7TS'
};

// Public reCAPTCHA Enterprise site key for konjoapp.com / Firebase Hosting.
// Firebase Auth, RTDB, Firestore, and Storage enforce App Check.
const RECAPTCHA_ENTERPRISE_SITE_KEY = '6Lfl6r8tAAAAADETU5D66nx0gPU94aTRq0xwZakd';

function isLocalHost() {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
}

// Debug tokens are development-only so a production build never embeds one.
if (process.env.NODE_ENV === 'development' && isLocalHost()) {
  // Must be set before App Check activate(). Prefer the token in .env.local.
  window.FIREBASE_APPCHECK_DEBUG_TOKEN =
    process.env.REACT_APP_APPCHECK_DEBUG_TOKEN || true;
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  try {
    const appCheck = firebase.appCheck();
    appCheck.activate(
      new firebase.appCheck.ReCaptchaEnterpriseProvider(RECAPTCHA_ENTERPRISE_SITE_KEY),
      true
    );
    if (process.env.NODE_ENV === 'development' && isLocalHost()) {
      console.info(
        '[Konjo] App Check debug mode is on for localhost. If Google Sign-In still returns an App Check 401, copy the debug token from this console and register it in Firebase Console → App Check → Manage debug tokens.'
      );
    }
  } catch (err) {
    console.error('[Konjo] App Check failed to initialize', err);
  }
}

export default firebase;
